import { AboutProcessSection } from "./AboutProcessSection";
import React from "react";
import {ICONS} from "../../../Constants/icons";
import { photosource } from "../../../Helpers/Feathure";

export class AboutPage extends React.Component {
    render() {
        return (
            <AboutProcessSection
                sections={[
                    {
                        eyebrow: "About our process",
                        title: "Restoration and maintenance",
                        text: "About our process text",
                        image: photosource("kG9kC6V5L0OG")
                    },
                    {
                        eyebrow: "Expertise and dedication",
                        title: "innovation and development",
                        text: "Expertise and dedication text",
                        image: photosource("ue7G62ycq9ye")
                    },
                ]}
            />
        );
    }
}
